import { useId, type ReactNode } from 'react';
import { Icon } from './Icon';

/** One flat disclosure in a vertical list, not another card or nested workspace. */
export function AccordionItem({ title, description, badge, open, disabled, onToggle, children, label = title }: {
  title: string;
  description?: string;
  badge?: ReactNode;
  open: boolean;
  disabled?: boolean;
  onToggle: () => void;
  children?: ReactNode;
  label?: string;
}) {
  const id = useId();
  return <section className="accordion-item">
    <h3 className="accordion-item__heading">
      <button className="accordion-item__trigger" type="button" id={`${id}-trigger`}
        aria-label={label} aria-expanded={open} aria-controls={`${id}-panel`}
        aria-describedby={description ? `${id}-description` : undefined} disabled={disabled} onClick={onToggle}>
        <Icon name="chevron" size={18} />
        <span className="accordion-item__title"><strong>{title}</strong>{description && <small id={`${id}-description`}>{description}</small>}</span>
        {badge && <span className="accordion-item__badge">{badge}</span>}
      </button>
    </h3>
    <div className="accordion-item__content" id={`${id}-panel`} role="region" aria-labelledby={`${id}-trigger`} hidden={!open}>
      {open && children}
    </div>
  </section>;
}
